import { render, staticRenderFns } from "./LayoutHasPagesTitle.vue?vue&type=template&id=00f68d92&scoped=true&"
import script from "./LayoutHasPagesTitle.vue?vue&type=script&lang=ts&"
export * from "./LayoutHasPagesTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f68d92",
  null
  
)

export default component.exports